module.exports = __webpack_public_path__ + "img/hangdao.df9d69dc.png";